<template>
    <div class="h-[calc(100vh-106px)] bg-[#0c1116] flex">


        <!-- Right Section: Transcript Content -->
        <div class="flex-1 mt-15 flex flex-col scrollbar-thumb-rounded-full scrollbar-thin scrollbar-track-rounded-full scrollbar scrollbar-thumb-[#f0f6ff57] scrollbar-track-transparent overflow-y-scroll" v-if="selectedTranscript.id">
          <div v-if="selectedTranscript.title" class="w-full max-w-[800px] px-8 md:px-8 sm:px-4 mx-auto">
            <div class="flex justify-between">
              <header class="flex gap-3 items-center">
                <div class="text-white text-[19px] font-semibold leading-[30px]" v-if="!isTitleEditing">{{ selectedTranscript.title }}</div>
                <div class="mb-2" v-else>
                  <input
                      v-model="selectedTranscript.title"
                      type="text"
                      name="transcript-title"
                      class="border-2 border-[#292F36] rounded-[10px] bg-transparent text-white font-normal text-base leading-[1.18rem] h-[44px] w-full pl-[10px] pr-[10px] outline-none focus:border-[#6CBFFF]"
                      />
                </div>
              </header>
            </div>
            <div class="font-inter text-[14px] font-medium leading-[20px] not-italic text-white/55 mt-1">{{ userName }}</div>
            <div class="font-inter text-[12px] leading-[20px] not-italic text-white/55 mt-1">{{ formatCreationDate(selectedTranscript.creationDate) }}</div>
            <div v-for="(group, index) in groupedMessages" :key="index" class="text-white/75">
              <div class="font-inter text-[12px] leading-[18px] not-italic text-primary mt-6 font-semibold sticky top-0 bg-[#0c1116] z-9 mb-1">{{ group.speaker }}</div>
              <div v-for="(msg, idx) in group.messages" :key="idx" class="mb-2">
                <div class="font-inter text-[14px] font-medium leading-[20px] not-italic text-white/89">{{ msg.source }}</div>
                <div v-if="msg.translations && Array.isArray(msg.translations)">
                  <div v-for="(translation, tIdx) in msg.translations" :key="tIdx" class="font-inter text-[14px] leading-[20px] not-italic text-white/75 ml-3 mt-1">
                    {{ translation.text }}
                  </div>
                </div>
              </div>
            </div>
            <router-link to="/plans" class="text-primary mt-4 px-5 py-[10px]">{{ $t('learn_more_about_forum') }}</router-link>

          </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import TranscriptService from "@/services/transcript.service";
import emitter from "@/services/emitter.service";
import { formatSessionBeganLabel } from "@/utils/transcript-date";

export default {
  name: 'SharedTranscriptView',
  components: {
  },
  data() {
    return {
      isEditing: false,
      isDeleting: false,
      settingsMenuOpen: false,
      deleteTranscriptId: null,
      searchQuery: '',
      selectedTranscript: {
        id: null,
        title: '',
        creationDate: '',
        messages: [],
        is_shared: false,
        shared_url: "http://localhost:8080/share/transcript/68c96fc9e5ebf36ab965505a"
      },
      userName: '',
      isTitleEditing: false,
      showShareModal: false,
    }
  }, 

  methods: {

    formatCreationDate(dateString) {
      return formatSessionBeganLabel(dateString);
    },
    selectTranscript(id) {
      TranscriptService.getSharedTranscript(id).then((data) => {
        const transcriptData = data.data.result;
        this.selectedTranscript.id = id;
        this.selectedTranscript.title = transcriptData.title;
        this.selectedTranscript.messages = transcriptData.messages.reverse();
        this.selectedTranscript.creationDate = transcriptData.creation_date;
        this.selectedTranscript.conference_id = transcriptData.conference_id;
        this.selectedTranscript.is_shared = transcriptData.is_shared;
      });
    }, 
    back(){
      this.$router.back();
      emitter.emit('open-account-popup');
    },
  },

  computed: {
    ...mapState('auth', ['token', 'authorized', 'agreed']),
    ...mapState('nonpersist', ['user']),
    groupedMessages() {
      const groups = [];
      let lastSpeaker = null;
      let currentGroup = null;
      for (const msg of this.selectedTranscript.messages) {
        if (msg.display_name !== lastSpeaker) {
          if (currentGroup){
            groups.push(currentGroup);
          }
          currentGroup = {
            speaker: msg.display_name,
            messages: [msg]
          };
          lastSpeaker = msg.display_name;
        } 
        else {
          currentGroup.messages.push(msg);
        }
      }
      if (currentGroup) groups.push(currentGroup);
      return groups;
  }
  },
  async mounted(){

    if (this.user){
      this.userName = this.user.name;
    }
  },

  async created() {
    if (this.$route.params.id) {
      this.selectTranscript(this.$route.params.id);
    }
  },
} 
</script>
